import { useLocation, Navigate } from 'react-router-dom';
import SEOLandingPage from '../../components/SEOLandingPage';
import ALL_SEO_PAGES from '../../data/allSeoPages';

export default function SeoPage() {
  const { pathname } = useLocation();
  // Pre-rendering requests /slug/ with a trailing slash, so strip both ends.
  const slug = pathname.replace(/^\/+|\/+$/g, '');
  const content = ALL_SEO_PAGES[slug];

  if (!content) {
    return <Navigate to="/" replace />;
  }

  return <SEOLandingPage content={content} />;
}
